var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 14.241C0.966667 14.241 0.652667 14.1106 0.391333 13.8497C0.130444 13.5884 0 13.2744 0 12.9077V3.57438C0 3.20771 0.130444 2.89371 0.391333 2.63238C0.652667 2.37149 0.966667 2.24105 1.33333 2.24105H4.13333C4.27778 1.84105 4.51956 1.51883 4.85867 1.27438C5.19733 1.02994 5.57778 0.907715 6 0.907715C6.42222 0.907715 6.80289 1.02994 7.142 1.27438C7.48067 1.51883 7.72222 1.84105 7.86667 2.24105H10.6667C11.0333 2.24105 11.3473 2.37149 11.6087 2.63238C11.8696 2.89371 12 3.20771 12 3.57438V12.9077C12 13.2744 11.8696 13.5884 11.6087 13.8497C11.3473 14.1106 11.0333 14.241 10.6667 14.241H1.33333ZM2.66667 11.5744H7.33333V10.241H2.66667V11.5744ZM2.66667 8.90771H9.33333V7.57438H2.66667V8.90771ZM2.66667 6.24105H9.33333V4.90771H2.66667V6.24105ZM6 3.07438C6.14444 3.07438 6.264 3.02705 6.35867 2.93238C6.45289 2.83816 6.5 2.71883 6.5 2.57438C6.5 2.42994 6.45289 2.31038 6.35867 2.21571C6.264 2.12149 6.14444 2.07438 6 2.07438C5.85556 2.07438 5.73622 2.12149 5.642 2.21571C5.54733 2.31038 5.5 2.42994 5.5 2.57438C5.5 2.71883 5.54733 2.83816 5.642 2.93238C5.73622 3.02705 5.85556 3.07438 6 3.07438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.f021cda4a485e3a417940f80b592ed64.svg";
export { ForwardRef as ReactComponent };